import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { branch, compose, renderComponent, renderNothing } from 'recompose';
import { Table } from 'react-bootstrap';
import UnreviewReasonPopover from '../../../components/UnreviewReasonPopover';


import { querySelector } from '../../../utils';
import '../style.css';

const propTypes = exact({
  jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedJobId: PropTypes.number.isRequired,
  selectJobId: PropTypes.func.isRequired,
});


const JobTable = (props) => {
  const { jobs, selectedJobId, selectJobId } = props;

  const handleRowColor = (job) => {
    let rowClass = 'none';

    if (job.state === 'unreviewed') {
      rowClass = 'unreviewed';
    }

    if (selectedJobId && job.id === selectedJobId) {
      rowClass = 'selected';
    }

    return rowClass;
  };

  const jobRow = (job) => {
    const {
      id,
      earliest_date,
      job_number,
      ticket_count,
      has_unreview_reasons,
      job_unreview_reasons,
    } = job;

    if (!earliest_date) {
      return null;
    }

    const listDate = `${earliest_date.month}/${earliest_date.day}`;
    const handleClick = () => { selectJobId(job.id); };
    const departments = querySelector(job, 'departments.edges[*].node.name', []);

    /* eslint-disable camelcase */
    return (
      // eslint-disable-next-line react/no-unknown-property
      <tr key={id} subject={id} onClick={handleClick} className={handleRowColor(job)}>
        <td>{listDate}</td>
        <td>{job_number}</td>
        <td>{departments.join(', ')}</td>
        <td>{ticket_count}</td>
        <td>
          {has_unreview_reasons && <UnreviewReasonPopover unreviewReasons={job_unreview_reasons} />}
        </td>
      </tr>
    );
    /* eslint-enable camelcase */
  };

  return (
    <Table>
      <thead>
        <tr>
          <th>Date</th>
          <th>Job</th>
          <th>Departments</th>
          <th>Ticket Count</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {jobs.map(jobRow, this)}
      </tbody>
    </Table>
  );
};


JobTable.propTypes = propTypes;


/*
* NOTE: This empty component depends on its parent being a panel.
* I'm not how to handle these HTML "dependencies" this at the moment.
*/
const withNoJobs = branch(
  (props) => { return props.jobs.length === 0; },
  renderComponent((props) => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        <h4>Empty</h4>
        <p className="text-muted">No Jobs are available for review</p>
      </div>
    );
  }),
);

const withNoSelectedJob = branch(
  (props) => { return props.selectedJobId === null; },
  renderNothing,
);


const enhance = compose(
  withNoJobs,
  withNoSelectedJob,
);

export default enhance(JobTable);
